import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiRequestService } from '../../shared/api-request.service';

@Injectable({
  providedIn: 'root'
})
export class SitesCodeService {
  private resourceUrl = environment.LARAVEL_API_URL + 'sites';

  constructor(private api: ApiRequestService) {}

  claimCode(siteId: number, paperId: string) {
    return this.api.makeRequestObservable(
      'patch',
      this.resourceUrl + `/${siteId}/qrcodes/claim`,
      { paper_id: paperId }
    );
  }
}
